// extracted by mini-css-extract-plugin
export default {"button":"createComment_button__ykEXi","container":"createComment_container__ACX+Y","change":"createComment_change__YaCrG","textarea":"createComment_textarea__+GrNQ"};